import React from "react";

import { telephoneNumberFormat } from "utils/utils";
import { Text } from "components";

import imageProfileDefault from "assets/icons/profile.png";
import clsx from "clsx";
import styled from "styled-components";

export default function SearchClients({ data, search, selectedClient, setSelectedClient }) {
	if (data.length === 0) {
		return (
			<div className="list-client none-client">
				{search.length === 0 ? "Encontrar seu cliente pelo nome ou número de telefone" : "Nenhum cliente encontrado"}
			</div>
		);
	}

	return data.map((client) => (
		<div key={client?.id} className="list-client">
			<button
				onClick={() => setSelectedClient(client)}
				className={clsx("client-btn-details", selectedClient?.id === client.id && "actived", client?.blocked && "blocked")}>
				<StyledLogo className="client-image" background={client?.avatarUrl} />
				<div>
					<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
						<Text align={"left"} className="client-name" style={{ marginLeft: "10px" }}>
							{client?.name}
						</Text>
						{client?.blocked && <span className="client-blocked-badge">Bloqueado</span>}
					</div>
					<Text align={"left"} className="client-info">
						{telephoneNumberFormat(client?.phone)}
					</Text>
				</div>
			</button>
		</div>
	));
}

const StyledLogo = styled.div`
	background-image: url("${(props) => props.background || imageProfileDefault}");
	background-repeat: no-repeat;
	background-size: ${(props) => (props.background ? "cover" : "50%")};
	background-position: center;
`;
